<template>
  <div>
    <Bar
      :options="chartOptions"
      :data="chartData"
      :style="chartStyles"
      ref="openReportsByStatusBar"
    />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import { ref, computed, defineComponent, onMounted } from "vue";
import { useNotification } from "@/composables/useNotification";
import { restClient } from "../../../lib/raftApi";

export default defineComponent({
  name: "OpenReportsByStatus",
  components: {
    Bar,
  },
  props: {
    chartWidth: { type: String, required: false, default: null },
    chartTitle: { type: String, required: true },
  },
  setup(props) {
    const { showNotification } = useNotification();
    const dataSet = ref([]);
    const chartLabels = ref([]);
    const openReportsByStatusBar = ref(null);
    /**
     * Fetch the report data from the REST endpoint, and use the response to set the chart data and labels.
     */
    async function fetchReportData() {
      const response = await restClient
        .get({ path: "incident-management/reports/status", queries: {} })
        .catch((e) => {
          showNotification("error", e.message);
        });
      if (response) {
        return response.forEach((dataPoint) => {
          chartLabels.value.push(dataPoint.label);
          dataSet.value.push(dataPoint.value);
        });
      }
    }
    // Fetch the data for the chart.
    fetchReportData();

    const chartStyles = computed(() => ({
      width: props.chartWidth,
      position: "relative",
    }));

    const chartOptions = computed(() => ({
      scales: {
        y: {
          beginAtZero: true,
          suggestedMax: 20,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: props.chartTitle,
        },
      },
    }));

    const chartData = computed(() => ({
      labels: chartLabels.value,
      datasets: [
        {
          data: dataSet.value,
          backgroundColor: [
            "#3366CC",
            "#DC3912",
            "#FF9900",
            "#109618",
            "#990099",
            "#3B3EAC",
            "#0099C6",
            "#DD4477",
            "#66AA00",
            "#B82E2E",
            "#316395",
            "#994499",
            "#22AA99",
            "#AAAA11",
            "#6633CC",
            "#E67300",
            "#8B0707",
            "#329262",
            "#5574A6",
            "#3B3EAC",
          ],
        },
      ],
    }));

    onMounted(() => {
      if (props.chartWidth !== null) {
        openReportsByStatusBar.value.$el.parentNode.style.width =
          props.chartWidth;
      }
    });

    return {
      chartOptions,
      chartData,
      chartStyles,
      dataSet,
      chartLabels,
      openReportsByStatusBar,
    };
  },
});
</script>

<style scoped></style>
